// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LongWriteActivityResultInfo } from './LongWriteActivityResultInfo'
import {
  LongWriteActivityResultInfoFromJSON,
  LongWriteActivityResultInfoFromJSONTyped,
  LongWriteActivityResultInfoToJSON,
} from './LongWriteActivityResultInfo'

/**
 *
 * @export
 * @interface LongWriteStudentResults
 */
export interface LongWriteStudentResults {
  /**
   *
   * @type {Array<LongWriteActivityResultInfo>}
   * @memberof LongWriteStudentResults
   */
  data?: Array<LongWriteActivityResultInfo> | null
  /**
   *
   * @type {number}
   * @memberof LongWriteStudentResults
   */
  totalCount?: number
}

/**
 * Check if a given object implements the LongWriteStudentResults interface.
 */
export function instanceOfLongWriteStudentResults(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteStudentResultsFromJSON(
  json: any,
): LongWriteStudentResults {
  return LongWriteStudentResultsFromJSONTyped(json, false)
}

export function LongWriteStudentResultsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteStudentResults {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: !exists(json, 'data')
      ? undefined
      : json['data'] === null
        ? null
        : (json['data'] as Array<any>).map(LongWriteActivityResultInfoFromJSON),
    totalCount: !exists(json, 'totalCount') ? undefined : json['totalCount'],
  }
}

export function LongWriteStudentResultsToJSON(
  value?: LongWriteStudentResults | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(LongWriteActivityResultInfoToJSON),
    totalCount: value.totalCount,
  }
}
